import { React, useState , useEffect} from "react";
import b1 from "../../videos2/Gangavathi.mp4";
import japllogo from '../../Images/Logo.jpeg';

const generateGoogleMapsURL = (lat, lng) =>
  `https://www.google.com/maps?q=${lat},${lng}`;

const generateQRCodeURL = (lat, lng) =>
  `https://api.qrserver.com/v1/create-qr-code/?data=${encodeURIComponent(generateGoogleMapsURL(lat, lng))}&size=100x100`;

// const API_BASE_URL = 'https://japl-backend.onrender.com/api'
const API_BASE_URL = (process.env.NODE_ENV === 'production' ? 'https://japl-backend-v2jm.onrender.com/api' : 'http://localhost:5000/api');
// const API_BASE_URL = 'http://localhost:5000/api'


const GangavathiWf = () => {

  const locations = {
    // 15.164335999747635, 76.83656877597824
    ballari: { lat:  15.16450373377266, lng: 76.83659385349404  }       // Danapuram coordinates 15.17613699827162, 76.36782308734786
  };

   // New: State for backend QR url
    const [qrUrl, setQrUrl] = useState(null);
  
    // Fetch QR code from backend on mount
    useEffect(() => {
      async function fetchBallariQR() {
        try {
          const res = await fetch(
            `${API_BASE_URL}/branchqrcode/Ballari`
          );
          if (res.ok) {
            const data = await res.json();
            // If backend returns a valid QR code, set it
            setQrUrl(data.qrCodeImageURL.startsWith('http') ? data.qrCodeImageURL : `https://japl-backend-v2jm.onrender.com/${data.qrCodeImageURL.replace(/^\//, '')}`);
          } else {
            setQrUrl(null);
          }
        } catch {
          setQrUrl(null);
        }
      }
      fetchBallariQR();
    }, []);
  
  const [formData, setFormData] = useState({
      name: "", phone: "", email: "", address: "", vehicleType: "",
      vehicleno: "", vehicleissue: "",
    });
    const [errors, setErrors] = useState({});
    const [result, setResult] = useState("");
    const [activeStep, setActiveStep] = useState(1);
  
    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData((prev) => ({ ...prev, [name]: value }));
      if (e.target.tagName === "TEXTAREA") {
        e.target.style.height = "auto";
        e.target.style.height = e.target.scrollHeight + "px";
      }
    };
  
    const validateForm = () => {
      const newErrors = {};
      if (!formData.name.trim()) newErrors.name = "Name is required";
      if (!formData.email.trim()) newErrors.email = "Email is required";
      if (!formData.phone.match(/^\d{10}$/)) newErrors.phone = "Phone must be 10 digits";
      if (!formData.address.trim()) newErrors.address = "Address is required";
      if (!formData.vehicleType) newErrors.vehicleType = "Model is required";
      if (!formData.vehicleno.trim()) newErrors.vehicleno = "Vehicle number is required";
      if (!formData.vehicleissue.trim()) newErrors.vehicleissue = "Vehicle Issues/Repairs is required";
      return newErrors;
    };
  
    const onSubmit = async (event) => {
      event.preventDefault();
      const validationErrors = validateForm();
      if (Object.keys(validationErrors).length > 0) {
        setErrors(validationErrors);
        return;
      }
      setResult("Sending...");
      const FORMSPREE_ENDPOINT = "https://formspree.io/f/xwpogdkq";
      try {
        const response = await fetch(FORMSPREE_ENDPOINT, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        });
        if (response.ok) {
          setResult("Booking Confirmed!");
          setActiveStep(3);
          setFormData({ name: "", phone: "", email: "", address: "", vehicleType: "", vehicleno: "", vehicleissue: "" });
        } else setResult("Submission failed. Try again.");
      } catch {
        setResult("Network error. Please try again.");
      }
    };
  

  return (
    <div className="min-h-screen bg-gray-50 font-sans">
      {/* Hero Section with Video */}
      <div className="relative">
        <video
          className="w-full h-[400px] object-cover"
          autoPlay
          loop
          muted
          playsInline
        >
         <source src='https://res.cloudinary.com/dk10z0h1f/video/upload/v1742362339/KKP_WS_inwgcn.mp4' type="video/mp4" />
           Your browser does not support the video tag.
                    </video>
        <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
          <div className="text-center px-4">
            <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Janatha Automobiles Private Limited
            </h1>
            <p className="text-xl text-white">
            Near Chaitanya Fuels, kolagal village, Ballari, Karnataka - 583101
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Card Container */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Location QR Card */}
          <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
            <div className="flex flex-col items-center gap-4 h-full">
                 <img src={japllogo} alt="japl logo" className="w-12 h-12 md:w-20 md:h-20 lg:w-28 lg:h-28"/>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 mr-2 text-blue-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
                Our Location
              </h2>
              <div className="flex-1 flex flex-col items-center justify-center">
                <img
                  src={
                     qrUrl ||  
                    generateQRCodeURL(locations.ballari.lat, locations.ballari.lng)}
                  alt="QR Code"
                  className="w-48 h-48 border-4 border-blue-100 rounded-xl p-2 bg-white"
                />
                <p className="mt-4 text-blue-600 text-center">
                  Scan to get directions to our service center
                </p>
              </div>
              <div className="mt-6 bg-blue-50 rounded-lg p-3">
                <p className="text-sm text-gray-700">
                  <strong>Address:</strong>Near Chaitanya Fuels, kolagal village, Ballari, Karnataka - 583101
                </p>
                <p className="text-sm pt-2 text-gray-700">
                  <strong>Call:</strong> 6364861935
                </p>
              </div>
            </div>
          </div>

           {/* Booking Form Card */}
          <div className="lg:col-span-2 bg-white rounded-xl p-8 border border-gray-200 shadow-md">
            {/* Progress Steps */}
            <div className="flex justify-between mb-10 relative">
              <div className="absolute top-1/2 h-1 w-full bg-gray-200 -z-10"></div>
              {[1, 2, 3].map((step) => (
                <div key={step} className="flex flex-col items-center">
                  <div
                    className={`w-12 h-12 rounded-full flex items-center justify-center text-lg font-bold ${activeStep >= step
                        ? "bg-blue-600 text-white"
                        : "bg-gray-200 text-gray-600"
                      }`}
                  >
                    {step}
                  </div>
                  <span className="mt-2 text-sm text-gray-600">
                    {step === 1 ? "Details" : step === 2 ? "Service" : "Confirm"}
                  </span>
                </div>
              ))}
            </div>

            {/* Form Content */}
            {activeStep === 1 && (
              <div className="animate-fadeIn">
                <h2 className="text-2xl font-semibold text-gray-800 mb-6">Personal Information</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Full Name
                    </label>
                    <div className="relative">
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="John Doe"
                      />
                      {errors.name && (
                        <p className="mt-1 text-sm text-red-600">{errors.name}</p>
                      )}
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Email Address
                    </label>
                    <div className="relative">
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="john@example.com"
                      />
                      {errors.email && (
                        <p className="mt-1 text-sm text-red-600">{errors.email}</p>
                      )}
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Phone Number
                    </label>
                    <div className="relative">
                      <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="9876543210"
                      />
                      {errors.phone && (
                        <p className="mt-1 text-sm text-red-600">{errors.phone}</p>
                      )}
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Address
                    </label>
                    <div className="relative">
                      <input
                        type="text"
                        name="address"
                        value={formData.address}
                        onChange={handleChange}
                        className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="Your complete address"
                      />
                      {errors.address && (
                        <p className="mt-1 text-sm text-red-600">{errors.address}</p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="mt-8 flex justify-end">
                  <button
                    type="button"
                    onClick={() => setActiveStep(2)}
                    className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition duration-200 shadow hover:shadow-md"
                  >
                    Next: Service Details
                  </button>
                </div>
              </div>
            )}

            {activeStep === 2 && (
              <div className="animate-fadeIn">
                <h2 className="text-2xl font-semibold text-gray-800 mb-6">Service Information</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Vehicle Model
                    </label>
                    <select
                      name="vehicleType"
                      value={formData.vehicleType}
                      onChange={handleChange}
                      className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none"
                    >
                      <option value="">Select Model</option>
                      <option value="M&HCV Construck">M&HCV Construck</option>
                      <option value="M&HCV Cargo">M&HCV Cargo</option>
                      <option value="LCV">LCV</option>
                      <option value="ICV">ICV</option>
                      <option value="MCV">MCV</option>
                      <option value="Busses">Busses</option>
                    </select>
                    {errors.vehicleType && (
                      <p className="mt-1 text-sm text-red-600">{errors.vehicleType}</p>
                    )}
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Vehicle Number
                    </label>
                    <input
                      type="text"
                      name="vehicleno"
                      value={formData.vehicleno}
                      onChange={handleChange}
                      className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="KA01AB1234"
                    />
                    {errors.vehicleno && (
                      <p className="mt-1 text-sm text-red-600">{errors.vehicleno}</p>
                    )}
                  </div>
                
                  {/* <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Service Type
                    </label>
                    <select
                      name="serviceType"
                      value={formData.serviceType}
                      onChange={handleChange}
                      className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none"
                    >
                      <option value="">Select Service</option>
                      <option value="Free Service">Free Service</option>
                      <option value="Paid Service">Paid Service</option>
                      <option value="Other">Other</option>
                    </select>
                    {errors.serviceType && (
                      <p className="mt-1 text-sm text-red-600">{errors.serviceType}</p>
                    )}
                  </div> */}
                  {/* <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Service Date
                    </label>
                    <input
                      type="date"
                      name="servicedate"
                      value={formData.servicedate}
                      onChange={handleChange}
                      className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                    {errors.servicedate && (
                      <p className="mt-1 text-sm text-red-600">{errors.servicedate}</p>
                    )}
                  </div> */}
                  {/* <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Preferred Time
                    </label>
                    <select
                      name="apptime"
                      value={formData.apptime}
                      onChange={handleChange}
                      className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none"
                    >
                      <option value="">Select Time Slot</option>
                      <option value="11:00 AM - 12:00 PM">11:00 AM - 12:00 PM</option>
                      <option value="1:00 PM - 2:00 PM">1:00 PM - 2:00 PM</option>
                      <option value="2:00 PM - 3:00 PM">2:00 PM - 3:00 PM</option>
                      <option value="3:00 PM - 4:00 PM">3:00 PM - 4:00 PM</option>
                      <option value="4:00 PM - 5:00 PM">4:00 PM - 5:00 PM</option>
                    </select>
                    {errors.apptime && (
                      <p className="mt-1 text-sm text-red-600">{errors.apptime}</p>
                    )}
                  </div> */}
                </div>
                <div className="mt-6">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Vehicle Issues / Repairs
                    </label>
                    <textarea
                      name="vehicleissue"
                      value={formData.vehicleissue}
                      onChange={handleChange}
                      className="w-full min-h-[150px] bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="Describe the vehicle issues or repairs needed..."
                      rows={6}
                    />
                    {errors.vehicleissue && (
                      <p className="mt-1 text-sm text-red-600">{errors.vehicleissue}</p>
                    )}
                  </div>
                <div className="mt-8 flex justify-between">
                  <button
                    type="button"
                    onClick={() => setActiveStep(1)}
                    className="px-6 py-3 bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium rounded-lg transition duration-200"
                  >
                    Back
                  </button>
                  <button
                    type="button"
                    onClick={onSubmit}
                    className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition duration-200 shadow hover:shadow-md flex items-center"
                  >
                    Confirm Booking
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 ml-2"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 001.414 1.414L9 9.414V13a1 1 0 102 0V9.414l1.293 1.293a1 1 0 001.414-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            )}

            {activeStep === 3 && (
              <div className="animate-fadeIn text-center py-12">
                <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-12 w-12 text-green-600"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                </div>
                <h2 className="text-3xl font-bold text-gray-800 mb-4">Booking Confirmed!</h2>
                <p className="text-xl text-blue-600 mb-8">
                  Your service appointment has been scheduled successfully.
                </p>
                <div className="bg-blue-50 rounded-xl p-6 max-w-md mx-auto text-left">
                  <h3 className="text-lg font-semibold text-gray-800 mb-4">Appointment Details</h3>
                  <div className="space-y-3">
                    <div className="flex justify-between">
                      <span className="text-gray-600">Date:</span>
                      <span className="text-gray-800">{formData.servicedate}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Time:</span>
                      <span className="text-gray-800">{formData.apptime}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Vehicle:</span>
                      <span className="text-gray-800">{formData.vehicleType}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Service:</span>
                      <span className="text-gray-800">{formData.serviceType}</span>
                    </div>
                  </div>
                </div>
                <button
                  type="button"
                  onClick={() => {
                    setActiveStep(1);
                    setResult("");
                  }}
                  className="mt-8 px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition duration-200"
                >
                  Book Another Service
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Global Styles */}
      <style jsx global>{`
        .animate-fadeIn {
          animation: fadeIn 0.5s ease-out;
        }
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default GangavathiWf;
